import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../authAxios";
import VerifedGif from "../../Assets/verifed.gif"; // Path to verified GIF
import DeniedGif from "../../Assets/denied.gif"; // Path to denied GIF
// import {useNavigate} from "react-router-dom"

const ResultPage = () => {
  const location = useLocation();
  const { key } = location.state || {}; // Access the key from state
  const [verificationStatus, setVerificationStatus] = useState(null); // null for no status yet
  const [verificationMsg, setVerificationMsg] = useState("");
  // const [logId , setlogId ] = useState(null)

  // const navigate = useNavigate();

  // const navigate = useNavigate()

  useEffect(() => {
    if (key) {
      axios
        .get(`/verify-pass/${key}`) // Removed unnecessary colon before key
        .then((res) => {
          console.log("here",res);
          setVerificationStatus(res.data.status ? true : false); // true or false
          setVerificationMsg(res.data.message); // Response message
          // setlogId(res.data.data.log_id);
        })
        .catch((err) => {
          setVerificationStatus(false); // Assume failure on error
          setVerificationMsg("Error verifying pass. Please try again.");
          console.log(err);
        });
    }
  }, [key]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100vh",
        padding: "20px", // Add some padding to the main container
        boxSizing: "border-box",
        paddingTop: "60px",
        backgroundColor: "#000000 1"
      }}
    >
      <div style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",


      }}>
        {key ? (
          <div>
            {verificationStatus === true && (
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}>
                <img
                  src={VerifedGif}
                  alt="Verified"
                  style={{ width: "200px", marginBottom: "15px" }}
                />
                <p style={{ color: "green", fontWeight: "bold", fontSize: "18px" }}>
                  {verificationMsg}
                </p>

                {/* <button
                  onClick={() => {
                    axios
                    .post("/complete-checkout", { id:logId }).then((res) => {
                      console.log(res);
                      if (res.data.status) {
                         navigate("/scanner");
                      } else {
                        alert("Error completing checkout. Please try again.");
                      }
                    });
                  
                  }}
                  style={{
                    padding: "15px 40px",
                    fontSize: "18px",
                    backgroundColor: "#143785",
                    color: "white",
                    borderRadius: "30px",
                    cursor: "pointer",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    boxShadow: "0 4px 15px rgba(20, 55, 133, 0.3)",
                    transition: "all 0.3s ease",
                    border: "none",
                    ":hover": {
                      backgroundColor: "#1a4ba3",
                      transform: "translateX(-50%) translateY(-2px)",
                      boxShadow: "0 6px 20px rgba(20, 55, 133, 0.4)",
                    },
                  }}
                >
                  End Visit
                </button> */}
              </div>
            )}
            {verificationStatus === false && (
              <div>
                <img
                  src={DeniedGif}
                  alt="Denied"
                  style={{ width: "200px", marginBottom: "15px" }}
                />
                <p style={{ color: "red", fontWeight: "bold", fontSize: "18px" }}>
                  {verificationMsg}
                </p>
                <button
                  onClick={() => {
                    window.location.href = "/scanner";
                  }}
                  style={{
                    padding: "15px 40px",
                    fontSize: "18px",
                    backgroundColor: "#143785",
                    color: "white",
                    borderRadius: "30px",
                    cursor: "pointer",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    boxShadow: "0 4px 15px rgba(20, 55, 133, 0.3)",
                    transition: "all 0.3s ease",
                    border: "none",
                    ":hover": {
                      backgroundColor: "#1a4ba3",
                      transform: "translateX(-50%) translateY(-2px)",
                      boxShadow: "0 6px 20px rgba(20, 55, 133, 0.4)",
                    },

                  }}
                >
                  Scan Again
                </button>

              </div>
            )}
            {verificationStatus === null && (
              <p style={{ fontSize: "16px", color: "#555" }}>Verifying, please wait...</p>
            )}
          </div>
        ) : (
          <p style={{ color: "red", fontWeight: "bold", fontSize: "18px" }}>
            No data found. Please scan again.
          </p>
        )}
      </div>
    </div>
  );
};

export default ResultPage;
